import React from "react";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface RoomCellProps {
  id?: string;
  roomNumber?: number;
  roomType?: string;
  className?: string;
  roomNumberClassName?: string;
}

export const RoomCell: React.FC<RoomCellProps> = ({
  id,
  roomNumber,
  roomType,
  className,
  roomNumberClassName,
}) => {
  if (!roomNumber || !id) {
    return <div className={cn("text-center", className)}>-</div>;
  }

  return (
    <Link
      to={`/reservations/rooms/${id}`}
      onClick={(event) => event.stopPropagation()}
      className={cn(
        "flex flex-col text-base tracking-tight text-center",
        className,
      )}
    >
      <span className={roomNumberClassName}>{roomNumber}</span>
      <span className={"capitalize"}>{roomType?.toLowerCase()}</span>
    </Link>
  );
};
